const Repository = require('../base')

class SettingsRepository extends Repository {
    constructor() {
        super({
            source: 'elastic'
        })
    }
}

module.exports = SettingsRepository
